import React from 'react';
import styled from 'styled-components';

const Input = styled.input`
 width:${props => props.width};
 margin:${props => props.margin};
 line-height: 28px;
 border: 2px solid transparent;
 border-bottom-color: #777;
 padding: .2rem 0;
 outline: none;
 background-color: transparent;
 color: #0d0c22;
 transition: .3s cubic-bezier(0.645, 0.045, 0.355, 1);
 &:focus{
 outline: none;
 padding: .2rem 1rem;
 border-radius: 1rem;
 border-color: #7a9cc6;
 }
 &:hover{
 outline: none;
 padding: .2rem 1rem;
 border-radius: 1rem;
 border-color: #7a9cc6;
 }
 &::placeholder{
  color: #777;
 }
 &:focus::placeholder{
  opacity: 0;
 transition: opacity .3s;
 }
`


export const InputBox = (props) => {
  return (  
     <Input {...props} />  
  )
}